/*
 * Convert SVG shapes into equivalent "path" shapes for use by PIXI JSON
 * @see simplify-svg-for-pixi.js for more information
 *
 * (This code was originally adapted from an existing SVGO plugin named convertShapeToPath in the SVGO plugins folder)
 *
 * NOTE: the object in this file depend on being in the format provided by calling XmlJs.xml2js(svg, { compact: false })
 * see https://github.com/JFXtras/jfxtras-labs/blob/2.2/src/main/java/jfxtras/labs/util/ShapeConverter.java
 */
import { path, tail } from 'ramda'

const fn = item => {
    const attr = path(['attrs', 'fill'], item)
    const fill = path(['attrs', 'fill', 'value'], item)
    if (fill && fill.match(/^#[0-9a-f]{3}$/i)) {
        const [a, b, c] = tail(fill.split(''))
        attr.value = `#${a}${a}${b}${b}${c}${c}`
    }

    return item
}



const lengthenFillColor = {
    type       : 'perItem',
    active     : true,
    description: 'Convert three-character fill color to six characters (#FFF -> #FFFFFF)',
    fn,
}

export { lengthenFillColor }
